import { EmailTemplateState } from '../../types/emailTemplate/emailTemplate.types';
import {
  GET_EMAIL_TEMPLATES_REQUEST,
  GET_EMAIL_TEMPLATES_SUCCESS,
  GET_EMAIL_TEMPLATES_FAILURE,
  GET_EMAIL_TEMPLATE_REQUEST,
  GET_EMAIL_TEMPLATE_SUCCESS,
  GET_EMAIL_TEMPLATE_FAILURE,
  CREATE_EMAIL_TEMPLATE_REQUEST,
  CREATE_EMAIL_TEMPLATE_SUCCESS,
  CREATE_EMAIL_TEMPLATE_FAILURE,
  UPDATE_EMAIL_TEMPLATE_REQUEST,
  UPDATE_EMAIL_TEMPLATE_SUCCESS,
  UPDATE_EMAIL_TEMPLATE_FAILURE,
  DELETE_EMAIL_TEMPLATE_REQUEST,
  DELETE_EMAIL_TEMPLATE_SUCCESS,
  DELETE_EMAIL_TEMPLATE_FAILURE,
  EmailTemplatesActionTypes,
  CLEAR_EMAIL_TEMPLATE_SUCCESS,
  CLEAR_EMAIL_TEMPLATE_CREATE_SUCCESS,
  CLEAR_EMAIL_TEMPLATE_UPDATE_SUCCESS,
  CLEAR_EMAIL_TEMPLATE_ERROR,
  CHECK_LINKS_REQUEST,
  CHECK_LINKS_SUCCESS,
  CHECK_LINKS_FAILURE,
  CLEAR_CHECK_LINKS_RESULT,
} from './emailTemplates.types';

const initialState: EmailTemplateState = {
  emailTemplates: [],
  emailTemplatesById: {},
  loadingById: {},
  selectedEmailTemplate: null,
  loading: false,
  error: null,
  createSuccess: false,
  updateSuccess: false,
  checkLinksLoading: false,
  checkLinksResult: null,
  checkLinksError: null,
};

const emailTemplatesReducer = (
  state: EmailTemplateState = initialState,
  action: EmailTemplatesActionTypes
): EmailTemplateState => {
  switch (action.type) {
    case GET_EMAIL_TEMPLATES_REQUEST:
    case CREATE_EMAIL_TEMPLATE_REQUEST:
    case UPDATE_EMAIL_TEMPLATE_REQUEST:
    case DELETE_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_EMAIL_TEMPLATE_REQUEST:
      return {
        ...state,
        loadingById: {
          ...state.loadingById,
          [action.payload]: true,
        },
        error: null,
      };

    case GET_EMAIL_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        emailTemplates: action.payload,
        error: null,
      };

    case GET_EMAIL_TEMPLATE_SUCCESS:
      if (!action.payload) {
        return {
          ...state,
          error: null,
        };
      }
      const { [action.payload._id]: removed, ...remainingLoading } =
        state.loadingById;
      return {
        ...state,
        loadingById: remainingLoading,
        emailTemplatesById: {
          ...state.emailTemplatesById,
          [action.payload._id]: action.payload,
        },
        selectedEmailTemplate: action.payload,
        error: null,
      };

    case CREATE_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        emailTemplates: [action.payload, ...state.emailTemplates],
        emailTemplatesById: {
          ...state.emailTemplatesById,
          [action.payload._id]: action.payload,
        },
        selectedEmailTemplate: action.payload,
        error: null,
        createSuccess: true,
      };

    case UPDATE_EMAIL_TEMPLATE_SUCCESS:
      const existingIndex = state.emailTemplates.findIndex(
        (template) => template._id === action.payload._id
      );

      if (existingIndex !== -1) {
        // Update existing template
        return {
          ...state,
          loading: false,
          emailTemplates: state.emailTemplates.map((template) =>
            template._id === action.payload._id ? action.payload : template
          ),
          emailTemplatesById: {
            ...state.emailTemplatesById,
            [action.payload._id]: action.payload,
          },
          selectedEmailTemplate: action.payload,
          error: null,
          updateSuccess: true,
        };
      } else {
        // Add new template if not in list
        return {
          ...state,
          loading: false,
          emailTemplates: [action.payload, ...state.emailTemplates],
          emailTemplatesById: {
            ...state.emailTemplatesById,
            [action.payload._id]: action.payload,
          },
          selectedEmailTemplate: action.payload,
          error: null,
          updateSuccess: true,
        };
      }

    case DELETE_EMAIL_TEMPLATE_SUCCESS:
      const { [action.payload]: deleted, ...remainingTemplates } =
        state.emailTemplatesById;
      return {
        ...state,
        loading: false,
        emailTemplates: state.emailTemplates.filter(
          (template) => template._id !== action.payload
        ),
        emailTemplatesById: remainingTemplates,
        selectedEmailTemplate:
          state.selectedEmailTemplate?._id === action.payload
            ? null
            : state.selectedEmailTemplate,
        error: null,
      };

    case GET_EMAIL_TEMPLATES_FAILURE:
    case CREATE_EMAIL_TEMPLATE_FAILURE:
    case UPDATE_EMAIL_TEMPLATE_FAILURE:
    case DELETE_EMAIL_TEMPLATE_FAILURE:
      return {
        ...state,
        loading: false,
        selectedEmailTemplate: null,
        error: action.payload,
        createSuccess: false,
        updateSuccess: false,
      };
    case GET_EMAIL_TEMPLATE_FAILURE:
      const failedTemplateId = action.payload.templateId;
      const {
        [failedTemplateId]: removedFailed,
        ...remainingLoadingAfterFailure
      } = state.loadingById;
      return {
        ...state,
        loadingById: remainingLoadingAfterFailure,
        selectedEmailTemplate: null,
        error: action.payload.error,
        createSuccess: false,
        updateSuccess: false,
      };

    case CLEAR_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        createSuccess: false,
        updateSuccess: false,
      };

    case CLEAR_EMAIL_TEMPLATE_CREATE_SUCCESS:
      return {
        ...state,
        createSuccess: false,
      };

    case CLEAR_EMAIL_TEMPLATE_UPDATE_SUCCESS:
      return {
        ...state,
        updateSuccess: false,
      };

    case CLEAR_EMAIL_TEMPLATE_ERROR:
      return {
        ...state,
        error: null,
      };

    case CHECK_LINKS_REQUEST:
      return {
        ...state,
        checkLinksLoading: true,
        checkLinksError: null,
        checkLinksResult: null,
      };

    case CHECK_LINKS_SUCCESS:
      return {
        ...state,
        checkLinksLoading: false,
        checkLinksResult: action.payload,
        checkLinksError: null,
      };

    case CHECK_LINKS_FAILURE:
      return {
        ...state,
        checkLinksLoading: false,
        checkLinksResult: null,
        checkLinksError: action.payload,
      };

    case CLEAR_CHECK_LINKS_RESULT:
      return {
        ...state,
        checkLinksResult: null,
        checkLinksError: null,
      };

    default:
      return state;
  }
};

export default emailTemplatesReducer;
